import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration optimized for entitlement system
 * - Prevents unnecessary refetches to avoid flicker
 * - Configured with appropriate retry and stale time settings
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Prevent flicker by not refetching on window focus
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect unless data is stale
      refetchOnReconnect: 'always',
      // Retry failed queries with exponential backoff
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Default stale time for all queries
      staleTime: 30_000, // 30 seconds
      // Keep data in cache for 5 minutes after component unmounts
      gcTime: 5 * 60 * 1000, // 5 minutes (formerly cacheTime)
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
});